import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import {
	requestAccessToken,
	ZOOM_ACCESS_TOKEN_REQUEST, ZOOM_ACCESS_TOKEN_SUCCESS, ZOOM_ACCESS_TOKEN_FAILURE
} from './actions';
import { Alert } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import browserStorage from '../../common/services/browserStorage';

class AuthorizationCallback extends Component {
	constructor(props) {
		super(props);
		this.state = {
			accessTokenError: ''
		};
	}

	componentDidMount() {
		const { queryParams: { code }, storedData: { centerId } } = this.props;
		if (code) {
			this.props.requestAccessToken({ code, centerId }, null, (error) => this.setState({ accessTokenError: error }));
		}
	}

	render() {
		const { storedData: { franchiseeId, centerId }, t } = this.props;

		const backPath = `/franchisees/${franchiseeId}/centers/${centerId}`;

		const errorMessage = this.state.accessTokenError;

		return <ReduxBlockUi block={ZOOM_ACCESS_TOKEN_REQUEST} unblock={[ZOOM_ACCESS_TOKEN_SUCCESS, ZOOM_ACCESS_TOKEN_FAILURE]} renderChildren={false}>
			{errorMessage && <Alert bsStyle='danger'>{errorMessage}</Alert>}
			{!errorMessage && <Alert bsStyle='success'>{t('Zoom_OAuth_Success')}</Alert>}
			<Link to={backPath} className='btn btn-default'>{t('Common_Back')}</Link>
		</ReduxBlockUi>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const { configuration: { franchisor } } = state;
	const queryParams = queryString.parse(ownProps.location.search);
	// required data is stored in local storage before redirecting to Zoom authorization page, "state" param contains franchisorId and the local storage key separated with a '.'
	const stateParts = queryParams.state.split('.');
	const storedData = (stateParts.length === 2 && JSON.parse(browserStorage.getFromSessionStorage(franchisor, stateParts[1]))) || { franchiseeId: 0, centerId: 0 };

	return {
		queryParams,
		storedData
	};
};

export default connect(mapStateToProps, {
	requestAccessToken
})(withTranslation()(AuthorizationCallback));